module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_23-49f172c0d5d5829a05dae1bfa4b57f42.png";